import { jwtDecode } from "jwt-decode";

import { TokenSession } from "@evr/types";
import { localStorageHelper } from "@evr/utils";

interface RawTokenPayload {
  UserId: string;
  Username: string;
  UserSessionId: string;
  SoftwareId: string;
  OrganisationId: string;
  OrganisationEmail: string;
  OrganisationTransactionCurrency: string;
  OrganisationTaxCode: string;
  SoftwareLicenceId: string;
  LicenceName: string;
  LicenceType: string;
  LicenceExpiry: string;
  Roles: string;
  SsoRole: string;
}

export function getTokenSession(): TokenSession | null {
  var token = localStorageHelper.getItem("EVR_AuthToken");

  try {
    const raw = jwtDecode<RawTokenPayload>(token);

    const session: TokenSession = {
      userId: raw.UserId,
      username: raw.Username,
      userSessionId: raw.UserSessionId,
      softwareId: raw.SoftwareId,
      organisationId: raw.OrganisationId,
      organisationEmail: raw.OrganisationEmail,
      organisationTransactionCurrency: raw.OrganisationTransactionCurrency,
      organisationTaxCode: raw.OrganisationTaxCode,
      softwareLicenceId: raw.SoftwareLicenceId,
      licenceName: raw.LicenceName,
      licenceType: raw.LicenceType,
      licenceExpiry: raw.LicenceExpiry,
      roles: raw.Roles,
      ssoRole: raw.SsoRole,
    };

    return session;
  } catch (err) {
    console.error("Invalid token:", err);
    return null;
  }
}
